
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none"}},[_c('circle',{attrs:{"fill":"#E2F7F1","cx":"12","cy":"12","r":"9"}}),_c('path',{attrs:{"d":"M16.636 7.605l-.771 2.759c-.46 1.7-.846 2.911-1.16 3.636-.472 1.086-1.107 1.838-2.326 2.325-1.218.487-2.405.06-2.846-.256-.44-.315-1-.875-1.225-1.357-.224-.481-.486-1.197-.432-2.078.053-.88.597-1.816 1.498-2.44.9-.624 2.513-1.036 3.37-1.345.572-.205 1.869-.62 3.892-1.244z","fill":"#55B720"}}),_c('path',{attrs:{"fill":"#006621","d":"M7.951 16.313l1.876-1.876-.208-3.421.181.005.238 3.205 1.395-1.395-.206-2.399.177-.009.206 2.231 1.304-1.304-.129-1.62.138.001.149 1.46 1.693-1.606.113.113-1.608 1.692 1.335.023-.01.128-1.483.007-1.305 1.304 2.09.25-.026.153-2.24-.227-1.396 1.396 3.123.155-.023.153-3.31-.097-1.876 1.875z"}})])])
          )
        }
      }
    